import React from "react";

export default ({ flag, meta: { infoClassName, message, log }, onClickDelete }) => {
  log && console.log(log);
  return flag ? (
    <div className={`${infoClassName} notification is-fixed`}>
      <button className="delete" onClick={onClickDelete} />
      {message}
    </div>
  ) : null;
};



// WEBPACK FOOTER //
// ./src/components/Notification/index.js